module.exports = __webpack_public_path__ + "img/BZ.d86006be.svg";